// Backend `Base.Models.ServicePrincipalStatus` is decorated with `[JsonConverter(typeof(JsonStringEnumConverter))]`,
// so the API always sends/accepts the enum member name as a string, not its numeric value.
export enum ServicePrincipalStatus {
  Active = 'Active',
  Suspended = 'Suspended',
  Deleted = 'Deleted',
}

export interface IServicePrincipal {
  id: string
  name: string
  // Organization that owns this Service Principal. Nullable on the wire because
  // `ServicePrincipal.OrganizationId` is nullable in the DB (rows created before
  // the column existed); every SP created through the API always carries one.
  organizationId?: string | null
  status: ServicePrincipalStatus
  createdBy: string
  createdAt: string
  modifiedBy?: string | null
  modifiedAt?: string | null
}

export interface IServicePrincipalRole {
  roleId: string
  roleName: string
}

export interface IServicePrincipalDetail extends IServicePrincipal {
  roles: IServicePrincipalRole[]
}

export interface CreateServicePrincipalDto {
  name: string
  // Required by the API — the caller must be Admin/SuperUser of this Organization.
  organizationId: string
}

export interface UpdateServicePrincipalDto {
  name?: string
  status?: ServicePrincipalStatus
}

export interface GetServicePrincipalsParams {
  // Required unless the caller holds the System role — the API rejects an
  // unscoped query with 403 for every other caller.
  organizationId?: string
  status?: ServicePrincipalStatus
  paging?: boolean
  page?: number
  pageSize?: number
  orderBy?: string
  keyword?: string
}

// Matches Base.DTO.ApiQuery<T> — same wrapper shape used by License (`results`,
// `page`, `pageCount`, `pageSize`, `queryCount`, `firstRowIndex`, `lastRowIndex`).
export interface ServicePrincipalListResponse {
  results: IServicePrincipal[]
  page: number
  pageCount: number
  pageSize: number
  queryCount: number
  firstRowIndex: number
  lastRowIndex: number
}
